import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { WINDOW } from '@ess-front/shared/tokens';

interface DataLayerObject {
  event: string;
  [key: string]: unknown;
}

export interface WindowWithDataLayer extends Window {
  dataLayer?: DataLayerObject[];
}

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private readonly GOOGLE_TAG_MANAGER_URL = 'https://www.googletagmanager.com/gtm.js';
  private isInitialized = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window: WindowWithDataLayer,
  ) {}

  init(): void {
    if (!this.isInitialized) {
      this.isInitialized = true;
      this.injectCookiebotScript();
      this.initializeDataLayer();
      this.injectGtmScript();
      this.pushEvent('gtm.js', { 'gtm.start': new Date().getTime() });
    }
  }

  pushEvent(eventName: string, eventData?: Record<string, unknown>): void {
    this.window.dataLayer?.push({
      event: eventName,
      ...eventData,
    });
  }

  private injectGtmScript(): void {
    const script = this.document.createElement('script');
    script.async = true;
    script.src = `${this.GOOGLE_TAG_MANAGER_URL}?id=${environment.gtmApiKey}`;
    this.document.head.appendChild(script);
  }

  private initializeDataLayer(): void {
    this.window.dataLayer = [];
  }

  // Injects Cookiebot to show the cookie's consent banner
  private injectCookiebotScript(): void {
    const script = this.document.createElement('script');
    script.id = 'Cookiebot';
    script.src = 'https://consent.cookiebot.com/uc.js';
    script.type = 'text/javascript';
    script.setAttribute('data-cbid', environment.cbID);
    this.document.head.appendChild(script);
  }
}
